
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('app-theme') || 'default';
    });

    useEffect(() => {
        localStorage.setItem('app-theme', theme);
        // Apply dataset to body
        // We modify document.documentElement (html tag) or body. Body is safer for overrides.
        if (theme === 'default') {
            document.body.removeAttribute('data-theme');
        } else {
            document.body.setAttribute('data-theme', theme);
        }
    }, [theme]);

    // Available themes metadata for the UI
    const themes = [
        { id: 'default', name: 'Neural Loom Labs', color: '#4B45A3', description: 'Loom Indigo & Orven Teal' },
        { id: 'dark', name: 'Dark Mode', color: '#1f2937', description: 'Dark & Elegant' },
        { id: 'mindful', name: 'Mindful Clarity', color: '#14b8a6', description: 'Teal & Stone' },
        { id: 'warm', name: 'Warm Cognition', color: '#f97316', description: 'Terracotta & Sand' },
        { id: 'clinical', name: 'Clinical Pro', color: '#3b82f6', description: 'Navy & Grey' },
    ];

    return (
        <ThemeContext.Provider value={{ theme, setTheme, themes }}>
            {children}
        </ThemeContext.Provider>
    );
};
